import React, { useState } from "react";
import "./WhatsAppChat.css";

const PullModal = ({ isOpen, onClose, onPull }) => {
  const [remark, setRemark] = useState("");

  if (!isOpen) return null;

  const handleSubmit = (e) => {
    e.preventDefault();
    onPull(remark);
    setRemark("");
  };

  return (
    <div className="rekonic-modal-overlay" onClick={onClose}>
      <div className="rekonic-modal-box" onClick={(e) => e.stopPropagation()}>
        <h3 className="rekonic-modal-title">Pull Chat to Queue</h3>
        <form onSubmit={handleSubmit}>
          <label style={{ display: "block", fontSize: "12px", fontWeight: 600, marginBottom: "6px", color: "#334155" }}>
            Optional Agent Remark / Note:
          </label>
          <textarea
            className="rekonic-modal-input"
            placeholder="Add internal remark or notes for this conversation..."
            rows={4}
            value={remark}
            onChange={(e) => setRemark(e.target.value)}
          />
          <div className="rekonic-modal-actions">
            <button type="button" className="rekonic-modal-btn-cancel" onClick={onClose}>
              Cancel
            </button>
            <button type="submit" className="rekonic-modal-btn-submit">
              PULL CHAT
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default PullModal;
